import { __styles, mergeClasses } from '@griffel/react';
export const carouselCardClassNames = {
  root: 'fui-CarouselCard'
};
/**
 * Styles for the root slot
 */
const useStyles = /*#__PURE__*/__styles({
  root: {
    xawz: 0,
    Bh6795r: 0,
    Bnnss6s: 0,
    fkmc3a: "fg68ejw",
    B2u0y6b: "f6dzj5z"
  },
  autoSize: {
    xawz: 0,
    Bh6795r: 0,
    Bnnss6s: 0,
    fkmc3a: "fd9q35j",
    Bf4jedk: "fy77jfu",
    a9b677: "f14z66ap",
    B2u0y6b: "f6dzj5z"
  }
}, {
  d: [[".fg68ejw{flex:0 0 100%;}", {
    p: -1
  }], ".f6dzj5z{max-width:100%;}", [".fd9q35j{flex:0 0 auto;}", {
    p: -1
  }], ".fy77jfu{min-width:0;}", ".f14z66ap{width:auto;}"]
});
/**
 * Apply styling to the CarouselCard slots based on the state
 */
export const useCarouselCardStyles_unstable = state => {
  'use no memo';

  const {
    autoSize
  } = state;
  const styles = useStyles();
  state.root.className = mergeClasses(carouselCardClassNames.root, styles.root, autoSize && styles.autoSize, state.root.className);
  return state;
};